import React from "react";
import { motion } from "framer-motion";

const PILLARS = [
    {
        label: "Pillar I",
        title: "Intentional Networking Training",
        body: "Learn who you should actually be talking to, and why. Stop wasting coffees on conversations that lead nowhere.",
    },
    {
        label: "Pillar II",
        title: "Weekly Roundtables",
        body: "Honest, connection-first conversations. Real people, real stakes, facilitated so the quiet voices aren't drowned out.",
    },
    {
        label: "Pillar III",
        title: "Growth by Merit",
        body: "Show up. Contribute. Be seen. No badges for attendance. Only for the members who actually move the room forward.",
    },
];

const ThreePillars = () => {
    return (
        <section
            data-testid="three-pillars"
            className="relative border-y border-[#d4af37]/15 bg-[#080a1f]"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32">
                <div className="max-w-4xl mb-16 md:mb-24">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#f2c652] font-display mb-4">
                        II. The Philosophy
                    </div>
                    <h2 className="font-display font-black tracking-tighter text-5xl md:text-7xl lg:text-8xl leading-[0.9] text-[#f6f1e1]">
                        This isn't another{" "}
                        <span className="relative inline-block">
                            <span className="relative z-10">pitch&nbsp;fest.</span>
                            <span
                                className="absolute left-0 right-0 bottom-2 md:bottom-3 h-3 md:h-5 bg-gradient-to-r from-[#d4af37]/90 to-[#f2c652]/70 -z-0"
                                aria-hidden="true"
                            />
                        </span>
                    </h2>
                    <p className="mt-6 md:mt-8 text-[#f6f1e1]/60 font-body text-base md:text-lg max-w-2xl leading-relaxed">
                        Three pillars create an environment where authentic
                        networking thrives. We've structured this circle to
                        reward presence, not performance.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
                    {PILLARS.map((pillar, idx) => (
                        <motion.div
                            key={pillar.label}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: idx * 0.1 }}
                            className="border-t border-[#d4af37]/25 pt-8"
                            data-testid={`pillar-${idx + 1}`}
                        >
                            <div className="font-display text-xs uppercase tracking-[0.3em] text-[#f2c652] mb-6">
                                {pillar.label}
                            </div>
                            <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-[#f6f1e1] mb-4 leading-tight">
                                {pillar.title}
                            </h3>
                            <p className="text-[#f6f1e1]/60 font-body text-[15px] leading-relaxed">
                                {pillar.body}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ThreePillars;
